// extracted by mini-css-extract-plugin
export var editInput = "_gm-0";
export var editInputCompact = "_gm-2";
export var editInputLarge = "_gm-1";
export var editInputSmall = "_gm-3";